<!-- 
Loads a job from the psos-service and makes it available via the job field.
Registers a job_id field on the component.
Includes the notification mixin and makes message available via the message field.
-->
<script>
import Psos from "@/mixins/psos-service.vue";
import Notification from "@/mixins/notification.vue";
export default {
  mixins: [Psos, Notification],
  props: ["job_id"],
  data: function() {
    return {
      job: null
    };
  },
  computed: {
    sequenceName() {
      return this.content !== null ? this.content.id : "";
    },
    contentAvailable() {
      return this.content !== null;
    },
    succeededAnalyses() {
      if (this.content === null || !("computations" in this.content)) {
        return [];
      } else {
        return this.content.computations.map(c => c.tool);
      }
    },
    isSignalPeptide() {
      if (this.content !== null && "computations" in this.content) {
        for (let i in this.content.computations) {
          var computation = this.content.computations[i];
          for (let j in computation.results) {
            var result = computation.results[j];
            if ("signalpeptide" in result) {
              return result.signalpeptide ? "yes" : "no";
            }
          }
        }
      }
      return "not computed";
    },
    isMembraneProtein() {
      if (this.content !== null && "computations" in this.content) {
        for (let i in this.content.computations) {
          var computation = this.content.computations[i];
          for (let j in computation.results) {
            var result = computation.results[j];
            if ("topology" in result) {
              var membrane_sections = result.topology.filter(
                t => t.location === "membrane"
              );
              return membrane_sections.length > 0 ? "yes" : "no";
            }
          }
        }
      }
      return "not computed";
    },
    localisation() {
      if (this.content !== null && "computations" in this.content) {
        for (let i in this.content.computations) {
          var computation = this.content.computations[i];
          for (let j in computation.results) {
            var result = computation.results[j];
            if ("Localization" in result) {
              return result.Localization;
            }
          }
        }
      }
      return "not computed";
    },
    databaseHits() {
      if (this.content !== null && "computations" in this.content) {
        // compute the number of hits per database
        var hits = {};
        for (let i in this.content.computations) {
          var computation = this.content.computations[i];
          for (let j in computation.results) {
            var result = computation.results[j];
            if ("target" in result && "dbxref" in result.target) {
              var dbxref = result.target.dbxref;
              var db = dbxref.split(":")[0];
              if (!(db in hits)) {
                hits[db] = 0;
              }
              hits[db] = hits[db] + 1;
            }
          }
        }
        return hits;
      }
      return {};
    },
    referencedDatabaseEntries() {
      if (this.content !== null && "dbxrefs" in this.content) {
        // eslint-disable-next-line no-unused-vars
        return Object.keys(this.content.dbxrefs).map((x, i) => x);
      } else {
        return [];
      }
    }
  },
  methods: {
    loadJob: function() {
      let vm = this;
      this.psosService.job(
        this.job_id,
        function(data) {
          vm.loading = false;
          vm.job = data.json;
          vm.message = { text: "Job data retrieved", variant: "success" };
          vm.psosService.listen(
            vm.job_id,
            function(data) {
              vm.job = data.body;
            },
            function(error) {
              vm.message = { text: "Error " + error, variant: "danger" };
            }
          );
        },
        function(error) {
          if (error.status === 404) {
            vm.$router.replace({ path: "/notfound" });
          }
          vm.loading = false;
          vm.notFound = true;
          vm.message = { text: error, variant: "danger" };
        }
      );
    }
  },
  mounted: function() {
    this.loadJob();
  }
};
</script>
